import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { fadeUp } from "../config/animations";
import { motion } from "framer-motion";
import {
  departmentHeads,
  featuredMembers,
  mechanics,
} from "../Constants/memberList";

const AboutUs = ({ currentSection }) => {
  return (
    <Box
      id="team"
      sx={{
        position: "relative",
      }}
    >
      <Box
        id="main-1"
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "rgba(27, 48, 90, 1)",
        }}
      >
        <Box
          id="sub-1"
          sx={{
            paddingTop: 15,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "2.2rem",
                sm: "3.5rem",
                md: "5rem",
                lg: "5rem",
              },
              color: "rgba(33, 93, 213, 1)",
              textShadow: "0 2px 16px #000",
              fontWeight: 700,
              lineHeight: 1.1,
              wordWrap: "break-word",
            }}
          >
            Meet Our Leadership
          </Typography>
          <Typography
            variant="body1"
            fontSize={{
              xs: "1.1rem",
              sm: "1.2rem",
              md: "1.3rem",
              lg: "1.1rem",
            }}
            color="#fff"
            maxWidth={800}
            mx="auto"
            px={{ xs: 2, sm: 2, md: 0 }}
            sx={{ textShadow: "0 1px 8px #000", mt: 2, fontWeight: 400 }}
          >
            At FlyHi Trans Inc., our leadership team drives innovation and
            operational excellence. With decades of combined experience in
            logistics, safety, and fleet management, they ensure our company
            delivers reliable solutions across the U.S.
          </Typography>
        </Box>

        <Box
          id="sub-2"
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "100vh",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          {featuredMembers.map((member, i) => (
            <motion.div
              initial="hidden"
              animate={currentSection === "team" ? "hidden" : "visible"}
              variants={fadeUp}
            >
              <Box sx={{ textAlign: "center" }}>
                <Box
                  sx={{
                    width: 250, // slightly larger than image
                    height: 250,
                    borderRadius: "50%", // circular container
                    backgroundColor: "#cfcfcf", // white background
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: 3,
                    overflow: "hidden", // ensures image stays inside circle
                    mx: "auto",
                  }}
                >
                  <Box
                    component="img"
                    src={member.image}
                    alt={member.name}
                    sx={{
                      width: 250,
                      height: 250,
                      objectFit: "cover",
                    }}
                  />
                </Box>

                <Typography
                  variant="h5"
                  color="rgba(33, 93, 213, 1)"
                  maxWidth={700}
                  mx="auto"
                  sx={{
                    textShadow: "0 1px 8px #000",
                    fontWeight: 600,
                    mt: 2,
                    fontSize: {
                      xs: "1.6rem",
                      sm: "1.7rem",
                      md: "1.5rem",
                      lg: "1.8rem",
                    },
                  }}
                >
                  {member.name}
                </Typography>
                <Typography
                  variant="body1"
                  fontSize={{
                    xs: "1.1rem",
                    sm: "1.2rem",
                    md: "1.3rem",
                    lg: "1rem",
                  }}
                  color="#fff"
                  maxWidth={700}
                  mx="auto"
                  px={{ xs: 2, sm: 2, md: 0 }}
                  sx={{ textShadow: "0 1px 8px #000", fontWeight: 400 }}
                >
                  {member.role}
                </Typography>
              </Box>
            </motion.div>
          ))}
        </Box>
      </Box>

      <Box
        id="main-2"
        sx={{
          py: 10,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgb(253, 254, 242)",
        }}
      >
        <Box
          id="sub2-1"
          sx={{
            // paddingTop: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "2.2rem",
                sm: "2.5rem",
                md: "3rem",
                lg: "3rem",
              },
              color: "rgba(33, 93, 213, 1)",
              // textShadow: "0 2px 16px #000",
              fontWeight: 700,
              lineHeight: 1.1,
              wordWrap: "break-word",
            }}
          >
            Department Heads
          </Typography>
          <Typography
            variant="body1"
            fontSize={{
              xs: "1.1rem",
              sm: "1.2rem",
              md: "1.3rem",
              lg: "1.1rem",
            }}
            color="#000000"
            maxWidth={1000}
            mx="auto"
            px={{ xs: 2, sm: 2, md: 0 }}
            // sx={{ textShadow: "0 1px 8px #000", mt: 2, fontWeight: 400 }}
          >
            Our Department Heads are experienced leaders who oversee key
            functional areas of the organization. They ensure strategic
            alignment, operational efficiency, and continuous innovation within
            their departments.
          </Typography>
        </Box>
        <Box
          id="sub2-2"
          sx={{
            display: "flex",
            // flexWrap: "wrap", // allows wrapping if more than 3
            gap: 0, // spacing between items
            width: "100%",
            paddingTop: 5,
            alignItems: "center",
            justifyContent: "space-around",
            mx: "auto",
          }}
        >
          {departmentHeads.map((member, i) => (
            <motion.div
              key={i}
              initial="hidden"
              animate={currentSection === "team" ? "hidden" : "visible"}
              variants={fadeUp}
            >
              <Box sx={{ textAlign: "center" }}>
                {/* Circular Image with Background */}
                <Box
                  sx={{
                    width: 180,
                    height: 180,
                    borderRadius: "50%",
                    backgroundColor: "rgba(27, 48, 90, 1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: 3,
                    overflow: "hidden",
                    mx: "auto",
                  }}
                >
                  <Box
                    component="img"
                    src={member.image}
                    alt={member.name}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                </Box>

                {/* Name */}
                <Typography
                  variant="h6"
                  color="rgba(33, 93, 213, 1)"
                  sx={{
                    fontWeight: 600,
                    mt: 2,
                    fontSize: {
                      xs: "1rem",
                      sm: "1.2rem",
                      md: "1.2rem",
                      lg: "1.3rem",
                    },
                  }}
                >
                  {member.name}
                </Typography>

                {/* Role */}
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 600,
                    color: "#000000",
                    // textShadow: "0 1px 8px #000",
                    fontSize: {
                      xs: "1rem",
                      sm: "1.1rem",
                      md: "1.1rem",
                      lg: "1rem",
                    },
                  }}
                >
                  {member.role}
                </Typography>

                {/* Description */}
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 400,
                    color: "#000000",
                    // textShadow: "0 1px 8px #000",
                    // mt: 1,
                    mx: "auto",
                    width: "80%",
                  }}
                >
                  {member.desc}
                </Typography>
              </Box>
            </motion.div>
          ))}
        </Box>

        <Box
          sx={{
            width: "75%",
            height: "2px",
            background: "linear-gradient(to right, #000000, #1394fe, #000000)",
            borderRadius: "2px",
            my: 4,
          }}
        />
        <Box
          id="sub2-2"
          sx={{
            display: "flex",
            // flexWrap: "wrap", // allows wrapping if more than 3
            gap: 0, // spacing between items
            width: "80%",
            paddingTop: 3,
            alignItems: "center",
            justifyContent: "space-around",
            mx: "auto",
          }}
        >
          {mechanics.map((member, i) => (
            <motion.div
              key={i}
              initial="hidden"
              animate={currentSection === "team" ? "hidden" : "visible"}
              variants={fadeUp}
            >
              <Box sx={{ textAlign: "center" }}>
                {/* Circular Image with Background */}
                <Box
                  sx={{
                    width: 150,
                    height: 150,
                    borderRadius: "50%",
                    backgroundColor: "rgba(27, 48, 90, 1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: 3,
                    overflow: "hidden",
                    mx: "auto",
                  }}
                >
                  <Box
                    component="img"
                    src={member.image}
                    alt={member.name}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                </Box>

                {/* Name */}
                <Typography
                  variant="h6"
                  color="rgba(33, 93, 213, 1)"
                  sx={{
                    fontWeight: 600,
                    mt: 2,
                    fontSize: {
                      xs: "1rem",
                      sm: "1.2rem",
                      md: "1.2rem",
                      lg: "1.3rem",
                    },
                  }}
                >
                  {member.name}
                </Typography>

                {/* Role */}
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 600,
                    color: "#000000",
                    // textShadow: "0 1px 8px #000",
                    fontSize: {
                      xs: "1rem",
                      sm: "1.1rem",
                      md: "1.1rem",
                      lg: "1rem",
                    },
                  }}
                >
                  {member.role}
                </Typography>

                {/* Description */}
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 400,
                    color: "#000000",
                    // textShadow: "0 1px 8px #000",
                    // mt: 1,
                    mx: "auto",
                    width: "90%",
                  }}
                >
                  {member.desc}
                </Typography>
              </Box>
            </motion.div>
          ))}
          <Box
            id="sub2-1"
            sx={{
              // paddingTop: 10,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "1.6rem",
                  sm: "2rem",
                  md: "2.1rem",
                  lg: "2.4rem",
                },
                color: "rgba(33, 93, 213, 1)",
                // textShadow: "0 2px 16px #000",
                fontWeight: 700,
                lineHeight: 1.1,
                wordWrap: "break-word",
              }}
            >
              Senior Diesel <br />
              Mechanics
            </Typography>
            <Typography
              variant="body1"
              fontSize={{
                xs: "1.1rem",
                sm: "1.2rem",
                md: "1.3rem",
                lg: "1.1rem",
              }}
              color="#000000"
              maxWidth={800}
              mx="auto"
              px={{ xs: 2, sm: 2, md: 0 }}
              // sx={{ textShadow: "0 1px 8px #000", mt: 2, fontWeight: 400 }}
            >
              Manages advanced diagnostics, major repairs, and preventive
              maintenance for diesel engines within the company’s facility,
              ensuring fleet reliability, compliance, and peak operational
              performance.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* <Box
        component={"img"}
        src="/aboutus_truck.png"
        alt="About Us Truck"
        mt={2}
        style={{
          width: "auto",
          maxHeight: "15rem",
        }}
      /> */}
      {/* <Box
        component={"img"}
        src="/about_truck2.png"
        alt="About Us Truck"
        mt={2}
        style={{
          width: "50rem",
          height: "25rem",
        }}
      /> */}

      <motion.img
        src={"/about_truck2.png"}
        alt="Truck"
        initial={{ opacity: 0, x: 400, scale: 0.5 }}
        whileInView={{ opacity: 1, x: 0, scale: 1 }}
        viewport={{ once: false }}
        transition={{ duration: 1, ease: "anticipate" }}
        style={{
          width: "50rem",
          height: "25rem",
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          pb: 5,
          px: { xs: 2, sm: 4, md: 6 },
        }}
      >
        <Typography
          variant="h3"
          align="center"
          sx={{
            color: "rgba(33, 93, 213, 1)",
            mb: 2,
          }}
        >
          Round-the-Clock Operations Support
        </Typography>

        <Typography
          variant="h6"
          align="center"
          width={1000}
          sx={{
            color: "rgb(0, 0, 0)",
            m: "auto",
            mb: 3,
            // textShadow: "0 1px 8px #000",
          }}
        >
          Provides dedicated, round-the-clock operational support to drivers and
          shippers, ensuring real-time communication, immediate problem
          resolution, load tracking, compliance coordination, and uninterrupted
          workflow management to guarantee safe, efficient, and on-time
          deliveries across all routes.
        </Typography>

        {/* <Grid
          container
          spacing={2}
          justifyContent="center"
          sx={{ maxWidth: 1000, mx: "auto" }}
        >
          {otherMembers.map((member, i) => (
            <Grid item xs={6} sm={4} md={2} key={i}>
              <Paper
                elevation={4}
                sx={{
                  p: 1.5,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.75)",
                  borderRadius: 2,
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                <img
                  src={member.image}
                  alt={member.name}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src =
                      "https://img.freepik.com/premium-vector/vector-flat-illustration-round-gray-man-icon-avatar-user-profile-person-icon-profile-picture-suitable-social-media-profiles-icons-screensavers-as-templatex9_719432-1794.jpg?semt=ais_hybrid&w=740&q=80";
                  }}
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginBottom: 8,
                  }}
                />
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, color: "#333" }}
                >
                  {member.name}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid> */}
      </Box>
    </Box>
  );
};

export default AboutUs;
